import { useState, useEffect } from 'react';

const SCRIPT_URL = "https://checkout.razorpay.com/v1/checkout.js";

export const useRazorpay = () => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    if (window.Razorpay) {
      setIsScriptLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = SCRIPT_URL;
    script.onload = () => setIsScriptLoaded(true);
    script.onerror = () => {
      console.error("Razorpay SDK failed to load.");
      setIsScriptLoaded(false);
    };
    document.body.appendChild(script);

    return () => {
    };
  }, []);

  const loadAndOpenRazorpay = (paymentOptions) => {
    return new Promise((resolve, reject) => {
      if (!isScriptLoaded) {
        console.error("Razorpay script is not loaded yet.");
        reject({ code: 'RAZORPAY_NOT_LOADED', message: "Razorpay script is not loaded yet." });
        return;
      }

      if (!paymentOptions.key) {
        console.error("Razorpay Key ID is missing.");
        reject({ code: 'RAZORPAY_KEY_MISSING', message: "Razorpay Key ID is missing." });
        return;
      }

      const amountInPaisa = Math.round(Number(paymentOptions.amount) * 100);
      if (isNaN(amountInPaisa) || amountInPaisa <= 0) {
        reject({ code: 'INVALID_AMOUNT', message: "Invalid payment amount." });
        return;
      }

      const hospitalName =
        process.env.REACT_APP_PAY_HOSPITAL_NAME || "Clinic Payment";

      const paymentDescription =
        process.env.REACT_APP_PAY_DESCRIPTION || "Payment for services";

      const normalizeColor = (color) => {
        if (!color) return "#3399cc";
        return color.startsWith("#") ? color : `#${color}`;
      };

      const themeColor = normalizeColor(
        process.env.REACT_APP_PAY_THEME_COLOUR
      );

      const patientRaw = localStorage.getItem("patient");
      const patient = patientRaw ? JSON.parse(patientRaw) : null;
      const prefill = {
        name: patient
          ? `${patient.salutation || ""} ${patient.firstName || ""} ${patient.lastName || ""}`.trim()
          : "",

        email: patient?.email || "",

        contact: patient?.phoneNumber || "",
      };

      const options = {
        key: paymentOptions.key,
        amount: amountInPaisa,
        currency: "INR",
        order_id: paymentOptions.orderId,

        name: hospitalName,
        description: paymentDescription,
        prefill,
        handler: (response) => {
          console.log("✅ Payment successful:", response);
          const referenceId = response.razorpay_payment_id;

          resolve({
            ...response,
            referenceId
          });
        },

        modal: {
          ondismiss: () => {
            reject({
              code: "RAZORPAY_CANCELLED",
              message: "Payment was cancelled.",
            });
          },
        },

        prefill: paymentOptions.prefill || {},
        notes: paymentOptions.notes || {},

        theme: {
          color: themeColor,
        },
      };


      try {
        const razor = new window.Razorpay(options);
        razor.open();
      } catch (error) {
        console.error("Failed to open Razorpay modal:", error);
        reject({ code: 'RAZORPAY_OPEN_FAILED', message: error.message });
      }
    });
  };

  return { loadAndOpenRazorpay, isScriptLoaded };
};